import { Typography } from '@material-tailwind/react';
import { TableCell, TableRow } from '@mui/material';
import React from 'react';

const TableNotFound = ({ colSpan = 4 }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Typography color="red" variant="small" className="font-extrabold uppercase text-center">
          Não encontrado!!!
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default TableNotFound;
